import React from 'react';

const FacebookSettingContext = React.createContext({
  settings: null,
  refetch: () => {},
  isLoading: null
});

export default FacebookSettingContext;
